// SOOLFY Theme JavaScript

document.addEventListener('DOMContentLoaded', function() {
  initPDP();
  initHome();
});

// === PRODUCT PAGE ===
function initPDP() {
  const gallery = document.querySelector('[data-gallery]');
  if (!gallery) return;

  const SWATCH_COLORS = window.SOOLFY_COLORS || { 'Rosé': '#F2C8B5', 'Butter': '#F4E69A', 'Eisblau': '#BCDFEA' };
  // --- Echte Shopify-Varianten (Farbe = option1, Größe = option2) ---
  let SET_VARIANTS = [];
  try { SET_VARIANTS = JSON.parse(document.querySelector('[data-set-variants]')?.textContent || '[]'); } catch(e) {}
  const variantByKey = {};
  SET_VARIANTS.forEach(v => { variantByKey[((v.option1||'').trim()) + '__' + ((v.option2||'').trim())] = v; });
  const DUO_PRICE = window.SOOLFY_DUO_PRICE || 99;
  const DUO_URL = window.SOOLFY_DUO_URL || '/products/lounge-duo';
  const hiddenIdInput = document.querySelector('[data-product-form] [name="id"]');
  function fmtEuro(n) { return n.toFixed(2).replace('.', ','); }
  function activeSingleColor() {
    const el = document.querySelector('[data-single-colors] .color-pick.is-active');
    if (el) return el.dataset.color;
    const n = document.querySelector('[data-single-color-name]');
    return n ? n.textContent.trim() : null;
  }
  function activeSingleSize() {
    const el = document.querySelector('[data-sizes] .size-pill.is-active');
    return el ? el.dataset.size : 'M';
  }
  function currentVariant() {
    return variantByKey[(activeSingleColor()||'').trim() + '__' + (activeSingleSize()||'').trim()] || null;
  }
  function syncVariant() {
    const v = currentVariant();
    if (v && hiddenIdInput) hiddenIdInput.value = v.id;
    updateATC();
  }
  const galleryMain = document.querySelectorAll('.gallery__main-item');
  const thumbsColorGroups = document.querySelectorAll('.gallery__thumbs-color');
  const allThumbs = document.querySelectorAll('.gallery__thumb');
  const galleryCount = document.querySelector('[data-count]');
  let currentColor = 'Rosé';
  let currentSlide = 0;

  function updateGallery() {
    galleryMain.forEach(item => {
      let active = false;
      if (currentSlide === 0) {
        active = item.classList.contains('gallery__main-video');
      } else {
        active = item.dataset.color === currentColor && parseInt(item.dataset.slide) === currentSlide;
      }
      item.classList.toggle('is-active', active);
    });
    thumbsColorGroups.forEach(g => {
      g.style.display = g.dataset.color === currentColor ? 'flex' : 'none';
    });
    allThumbs.forEach(t => {
      const slide = parseInt(t.dataset.slide);
      const color = t.dataset.color;
      let active = false;
      if (currentSlide === 0 && t.classList.contains('gallery__thumb--video')) active = true;
      else if (color === currentColor && slide === currentSlide) active = true;
      t.classList.toggle('is-active', active);
    });
    if (galleryCount) {
      galleryCount.textContent = currentSlide === 0 ? '▶ Video' : currentSlide + ' / 4';
    }
  }

  function setColor(color) {
    currentColor = color;
    if (currentSlide !== 0) currentSlide = 1;
    updateGallery();
    document.querySelectorAll('.fabric-swatch-img').forEach(img => {
      img.classList.toggle('is-active', img.dataset.fabricColor === color);
    });
    const fabricLabel = document.querySelector('[data-fabric-label]');
    const fabricName = document.querySelector('[data-fabric-name]');
    if (fabricLabel) fabricLabel.style.setProperty('--c', SWATCH_COLORS[color]);
    if (fabricName) fabricName.textContent = color;
  }

  allThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const slide = parseInt(thumb.dataset.slide);
      const color = thumb.dataset.color;
      if (slide === 0) currentSlide = 0;
      else {
        if (color !== currentColor) currentColor = color;
        currentSlide = slide;
      }
      updateGallery();
    });
  });

  const prevBtn = document.querySelector('[data-prev]');
  const nextBtn = document.querySelector('[data-next]');
  if (prevBtn) prevBtn.addEventListener('click', () => { currentSlide = (currentSlide - 1 + 5) % 5; updateGallery(); });
  if (nextBtn) nextBtn.addEventListener('click', () => { currentSlide = (currentSlide + 1) % 5; updateGallery(); });

  // BUNDLE
  const bundleOpts = document.querySelectorAll('.bundle-option');
  const singleBlock = document.querySelector('[data-single-color-block]');
  const dualBlock = document.querySelector('[data-dual-colors]');
  const sizeBlock = document.querySelector('[data-size-block]');
  const atcBtn = document.querySelector('[data-atc-btn]');
  const qtyInput = document.querySelector('[data-qty]');
  let bundle = 1;

  function updateBundleUI() {
    if (bundle === 1) {
      singleBlock && singleBlock.classList.remove('is-hidden');
      dualBlock && dualBlock.classList.remove('is-visible');
      if (sizeBlock) sizeBlock.style.display = '';
    } else {
      singleBlock && singleBlock.classList.add('is-hidden');
      dualBlock && dualBlock.classList.add('is-visible');
      if (sizeBlock) sizeBlock.style.display = 'none';
    }
    updateATC();
  }

  function updateATC() {
    if (!atcBtn) return;
    const qty = parseInt(qtyInput ? qtyInput.value : 1) || 1;
    if (bundle === 1) {
      const v = currentVariant();
      const unit = v ? v.price / 100 : 59.99;
      if (v && v.available === false) {
        atcBtn.textContent = 'Ausverkauft';
      } else {
        atcBtn.textContent = 'In den Warenkorb · ' + fmtEuro(unit * qty) + ' €';
      }
    } else {
      atcBtn.textContent = 'In den Warenkorb · ' + fmtEuro(DUO_PRICE * qty) + ' €';
    }
  }

  bundleOpts.forEach(opt => {
    opt.addEventListener('click', () => {
      bundleOpts.forEach(o => o.classList.remove('is-active'));
      opt.classList.add('is-active');
      bundle = parseInt(opt.dataset.bundle);
      updateBundleUI();
    });
  });

  // SINGLE COLOR
  document.querySelectorAll('[data-single-colors] .color-pick').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('[data-single-colors] .color-pick').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const color = btn.dataset.color;
      const nameEl = document.querySelector('[data-single-color-name]');
      if (nameEl) nameEl.textContent = color;
      setColor(color);
      syncVariant();
    });
  });

  // DUAL COLOR / SIZE
  document.querySelectorAll('[data-set="1"] .swatch-mini').forEach(sw => {
    sw.addEventListener('click', () => {
      document.querySelectorAll('[data-set="1"] .swatch-mini').forEach(x => x.classList.remove('is-active'));
      sw.classList.add('is-active');
      const color = sw.dataset.color;
      const nameEl = document.querySelector('[data-set1-name]');
      if (nameEl) nameEl.textContent = color;
      setColor(color);
      updateATC();
    });
  });
  document.querySelectorAll('[data-set="2"] .swatch-mini').forEach(sw => {
    sw.addEventListener('click', () => {
      document.querySelectorAll('[data-set="2"] .swatch-mini').forEach(x => x.classList.remove('is-active'));
      sw.classList.add('is-active');
      const nameEl = document.querySelector('[data-set2-name]');
      if (nameEl) nameEl.textContent = sw.dataset.color;
      updateATC();
    });
  });
  document.querySelectorAll('[data-set-size="1"] .size-mini').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.dataset.soldout) return;
      document.querySelectorAll('[data-set-size="1"] .size-mini').forEach(x => x.classList.remove('is-active'));
      btn.classList.add('is-active');
      const el = document.querySelector('[data-set1-size]');
      if (el) el.textContent = btn.dataset.size;
      updateATC();
    });
  });
  document.querySelectorAll('[data-set-size="2"] .size-mini').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.dataset.soldout) return;
      document.querySelectorAll('[data-set-size="2"] .size-mini').forEach(x => x.classList.remove('is-active'));
      btn.classList.add('is-active');
      const el = document.querySelector('[data-set2-size]');
      if (el) el.textContent = btn.dataset.size;
      updateATC();
    });
  });

  // SIZES (single)
  document.querySelectorAll('[data-sizes] .size-pill').forEach(p => {
    p.addEventListener('click', () => {
      document.querySelectorAll('[data-sizes] .size-pill').forEach(x => x.classList.remove('is-active'));
      p.classList.add('is-active');
      const sizeName = document.querySelector('[data-size-name]');
      if (sizeName) sizeName.textContent = p.dataset.size;
      syncVariant();
    });
  });

  // QTY
  const minusBtn = document.querySelector('[data-minus]');
  const plusBtn = document.querySelector('[data-plus]');
  if (minusBtn) minusBtn.addEventListener('click', () => { qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1); updateATC(); });
  if (plusBtn) plusBtn.addEventListener('click', () => { qtyInput.value = Math.min(10, parseInt(qtyInput.value) + 1); updateATC(); });
  if (qtyInput) qtyInput.addEventListener('input', updateATC);

  // ATC: Submit to Shopify cart
  if (atcBtn) {
    atcBtn.addEventListener('click', async () => {
      if (window.SoolfyCart) return; // Cart-Drawer übernimmt ATC (kein /cart-Redirect, auch mobil)
      // Duo = eigenes Produkt im Shop → dorthin leiten
      if (bundle === 2) {
        window.location.href = DUO_URL;
        return;
      }

      const qty = parseInt(qtyInput ? qtyInput.value : 1) || 1;
      const v = currentVariant();
      if (!v) {
        atcBtn.textContent = 'Bitte Farbe & Größe wählen';
        setTimeout(updateATC, 2000);
        return;
      }

      try {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Wird hinzugefügt…';
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
        });
        if (res.ok) {
          window.location.href = '/cart';
        } else {
          let msg = 'Fehler — bitte erneut versuchen';
          try { const err = await res.json(); if (err && err.description) msg = err.description; } catch(e) {}
          atcBtn.textContent = msg;
          atcBtn.disabled = false;
          setTimeout(updateATC, 2500);
        }
      } catch(e) {
        atcBtn.disabled = false;
        updateATC();
        console.error(e);
      }
    });
  }

  // Initialer Varianten-Sync (setzt versteckte ID auf aktuelle Farbe+Größe)
  syncVariant();
  updateBundleUI();
}

// === HOMEPAGE ===
function initHome() {
  // Color cards on home: click → smooth scroll to set
  document.querySelectorAll('.color-card[data-color]').forEach(card => {
    card.addEventListener('click', (e) => {
      const tease = document.getElementById('product-tease');
      if (tease) tease.scrollIntoView({behavior: 'smooth'});
    });
  });
  
  // Fabric section color picker (home)
  const SWATCH_COLORS = window.SOOLFY_COLORS || { 'Rosé': '#F2C8B5', 'Butter': '#F4E69A', 'Eisblau': '#BCDFEA' };
  document.querySelectorAll('[data-fabric-colors] .fabric-section__color').forEach(c => {
    c.addEventListener('click', () => {
      const color = c.dataset.color;
      document.querySelectorAll('[data-fabric-colors] .fabric-section__color').forEach(x => x.classList.remove('is-active'));
      c.classList.add('is-active');
      document.querySelectorAll('.fabric-img').forEach(img => {
        img.classList.toggle('is-active', img.dataset.fabricColor === color);
      });
      const label = document.querySelector('[data-fabric-label]');
      const name = document.querySelector('[data-fabric-name]');
      if (label) label.style.setProperty('--c', SWATCH_COLORS[color]);
      if (name) name.textContent = color;
    });
  });
}
